import * as React from 'react';
import { useMergeClasses, useTheme } from '../../../../../theme';
import cn from 'classnames';
import { List, CdnIcon, QntBadge } from '@shared/ui';
import { useToggleable } from '../../../../../hooks';
import Dropdown from '../../../../../Dropdown';
import { FilterProps } from '../model/types';

const FILTER_IGNORE_OUTSIDE_CLASS = 'filter-ignore-outside';

const Filter: React.FC<FilterProps> = ({
	/* Base props */
	classes,
	name,
	quantity,
	icon,
	variant = 'click',
	size = 'small',
	color = 'white',
	isSelected,
	isDisabled,
	dataTestId,
	dataFilter,
	dataAttributes,

	/* Click props */
	label,
	onClick,

	/* Dropdown props */
	value,
	options,
	onChange
}) => {
	const { Filter: defaultClasses } = useTheme('Shared');
	const theme = useMergeClasses(defaultClasses, classes);

	const { isOpen, close, toggle } = useToggleable(false);

	const isClick = variant === 'click';
	const isDropdown = variant === 'dropdown';

	const quantityElement =
		typeof quantity === 'number' ? <QntBadge classes={{ badge: theme.quantity }} count={quantity} /> : null;

	const handleClick = () => {
		isClick ? onClick() : toggle();
	};

	return (
		<div
			{...dataAttributes}
			data-test-id={dataTestId}
			data-filter={dataFilter}
			data-selected={isSelected ? 'true' : 'false'}
			className={cn(
				theme.root,
				theme[size],
				theme[color],
				{
					[theme.selected]: isSelected,
					[theme.disabled]: isDisabled,
					[theme.dropdown]: isDropdown,
					[theme.clickable]: onClick || isDropdown
				},
				FILTER_IGNORE_OUTSIDE_CLASS
			)}
			onClick={handleClick}
		>
			{!!name && <div className={theme.name}>{name}</div>}

			{isClick && (
				<>
					<div className={theme.label}>{label}</div>

					{quantityElement}
				</>
			)}

			{isDropdown && (
				<>
					<div className={theme.value}>{value.label}</div>

					{quantityElement}

					<CdnIcon className={cn(theme.arrowIcon, { [theme.open]: isOpen })} icon="Arrow/Drop_down" />

					<Dropdown isOpen={isOpen} onClose={close} outsideClickIgnoreClass={FILTER_IGNORE_OUTSIDE_CLASS}>
						<div className={theme.listWrapper}>
							<List options={options} value={value} onChange={onChange} />
						</div>
					</Dropdown>
				</>
			)}

			{icon && <div className={theme.icon}>{icon}</div>}
		</div>
	);
};

export default Filter;
